import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";

export const crearDeposito = async (entidad, usuario) => {


    let consecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'});

    let deposito = {
        idUsuario: usuario.id,
        fecha: new Date().getTime(),
        consecutivo: consecutivo,
        ...entidad
    }

    let dox = await guardarDoc('movimientos', deposito)


}